// @flow
import React from 'react';

export const STANDARD_WIDTH = 370;
export const STANDARD_HEIGHT = 60;
export const STANDARD_RADIUS_X = 2;
export const STANDARD_RADIUS_Y = 2;
export const STANDARD_MESSAGE_WIDTH = STANDARD_WIDTH - 90;
export const STANDARD_FILL = 'white';

type StandardNodeProps = {
  iconFill: string,
  icon: string,
  botLeftRounded?: boolean,
  topLeftRounded?: boolean,
  height?: number,
  rx?: number,
  ry?: number,
  children?: any
};

export const StandardNode = (props: StandardNodeProps) => {
  const {
    iconFill,
    icon,
    height = STANDARD_HEIGHT,
    rx = STANDARD_RADIUS_X,
    ry = STANDARD_RADIUS_Y,
    botLeftRounded,
    topLeftRounded,
    children
  } = props;

  return (
    <g>
      <rect x="10" width="50" height={`${height}`} fill={`${iconFill}`} />
      {!botLeftRounded && (
        <rect x="0" y="50" width="10" height="10" fill={`${iconFill}`} />
      )}
      {!topLeftRounded && (
        <rect x="0" y="0" width="10" height="10" fill={`${iconFill}`} />
      )}
      <rect
        rx={`${rx}`}
        ry={`${ry}`}
        width="20"
        height={`${height}`}
        fill={`${iconFill}`}
      />
      <use
        xlinkHref={`${icon}`}
        overflow="visible"
        width="35"
        height="35"
        fill="white"
      />
      <g transform="translate(75, 25)">{children}</g>
    </g>
  );
};

StandardNode.defaultProps = {
  botLeftRounded: true,
  topLeftRounded: true,
  children: null,
  height: STANDARD_HEIGHT,
  rx: STANDARD_RADIUS_X,
  ry: STANDARD_RADIUS_Y
};



// WEBPACK FOOTER //
// ./src/components/StandardNode.jsx